import { faCalendarDays, faEdit, faKey } from '@fortawesome/pro-solid-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { Descriptions, Space, Typography } from 'antd'
import { useState } from 'react'
import AvatarPicker from '../Avatar/AvatarPicker'
import VSpace from '../common/VSpace'
import { Account } from './accountApi'
import MemoryList from './MemoryList'
import './AccountDetails.css'
import { useUpdateAvatar, useUpdateDisplayName } from './accountQueries'
import UpdatePassword from './UpdatePassword'
export type Props = {
  account: Account
}

export const AccountDetails = ({ account }: Props) => {
  const { API_ENDPOINT } = (window as any).env ?? { API_ENDPOINT: '' }
  const webcalPrefix = `${API_ENDPOINT.replace(/^https?/, 'webcal')}/web/calendar-events`

  const [displayName, setDisplayName] = useState(account.displayName)
  const [updatedAvatar, setUpdatedAvatar] = useState<string>()

  const updateDisplayNameMutation = useUpdateDisplayName()
  const updateAvatarMutation = useUpdateAvatar()

  const handleDisplayNameChange = (newDisplayName: string) => {
    setDisplayName(newDisplayName)
    updateDisplayNameMutation.mutate(newDisplayName)
  }

  const handleAvatarChange = (newAvatar: string) => {
    setUpdatedAvatar(newAvatar)
    updateAvatarMutation.mutate(newAvatar, {
      onError: () => setUpdatedAvatar(undefined)
    })
  }

  return <div className="account-details">
    <section>
      <Space size="large">
        <AvatarPicker
          alt={account.displayName}
          src={updatedAvatar ?? `${account.avatar}?id=${Math.random()}`}
          onModalSubmit={handleAvatarChange}
        />

        <VSpace size="large">
          <Typography>
            <Space>
              <Typography.Title
                level={4}
                editable={{
                  onChange: handleDisplayNameChange,
                  icon: <FontAwesomeIcon icon={faEdit} size="xs" />,
                }}
              >
                {displayName}
              </Typography.Title>
            </Space>
            <div>{account.email}</div>
          </Typography>
        </VSpace>
      </Space>
    </section>
    <section>
      <Typography.Title level={4}>
        <Space>
          <FontAwesomeIcon icon={faCalendarDays} />
          Your calendar subscriptions
        </Space>
      </Typography.Title>
      <Descriptions bordered column={1}>
        <Descriptions.Item label="My Schedule (Jobs & Consultations)">
          <Typography.Text copyable>{`${webcalPrefix}/webcal/user?token=${account.token}`}</Typography.Text>
        </Descriptions.Item>
        <Descriptions.Item label="All Users Schedule (Jobs & Consultations)">
          <Typography.Text copyable>{`${webcalPrefix}/webcal/all?token=${account.token}`}</Typography.Text>
        </Descriptions.Item>
        <Descriptions.Item label="My Schedule (Consultations Only)">
          <Typography.Text copyable>{`${webcalPrefix}/consultations/user?token=${account.token}`}</Typography.Text>
        </Descriptions.Item>
        <Descriptions.Item label="All Users Schedule (Consultations Only)">
          <Typography.Text copyable>{`${webcalPrefix}/consultations/all?token=${account.token}`}</Typography.Text>
        </Descriptions.Item>
      </Descriptions>
    </section>
    <MemoryList />
    <section>
      <Typography.Title level={4}>
        <Space>
          <FontAwesomeIcon icon={faKey} />
          Update your password
        </Space>
      </Typography.Title>
      <UpdatePassword email={account.email} />
    </section>
  </div>
}

